/**
 * 共通ライブラリ統合エントリーポイント
 * すべての共通ライブラリ機能をエクスポート
 */

const auth = require('./auth');
const errorHandling = require('./error-handling');
const hallManagement = require('./hall-management');
const logging = require('./logging');
const userManagement = require('./user-management');

module.exports = {
  // 認証関連
  auth,
  
  // エラーハンドリング関連
  errorHandling,
  
  // ホール管理関連
  hallManagement,
  
  // ログ出力関連
  logging,
  
  // ユーザー管理関連
  userManagement,
  
  // 個別機能も直接エクスポート（利便性のため）
  ...auth,
  ...errorHandling,
  ...hallManagement,
  ...logging,
  ...userManagement
};

